const seeMore = document.querySelectorAll('.card__see-more');
const seeLess = document.querySelectorAll('.card__see-less');

for (let i = 0; i < seeMore.length; i++) {
    seeMore[i].addEventListener('click', function(){
        seeMore[i].closest('.card__content').querySelector('.card__more').classList.add('see-more');
    })
}

for (let i = 0; i < seeLess.length; i++) {
    seeLess[i].addEventListener('click', function(){
        seeLess[i].closest('.card__content').querySelector('.card__more').classList.remove('see-more');
    })
}


/*** Transcription textuelle  ***/
var transcription = document.querySelectorAll('.accordion--transcription');

for (let i = 0; i < transcription.length; i++) {
    transcription[i].addEventListener('keypress', function () {
        if (event.keyCode === 13) {
            transcription[i].querySelector('details').toggleAttribute("open");
        }
    })
}